export enum DeviceType {
  Camera = 'camera',
  Microphone = 'microphone',
}
